import { client } from 'utilities/db';
import { useQuery } from 'react-query';

export const useFetchKdsByBrands = (keyName, id) => {
  const { status, data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName, id],
    () => getData(id),
    {
      enabled: !!id,
      refetchInterval: 60000
    }
  );

  return {
    brandKdsStatus: status,
    brandKdsData: data,
    brandKdsError: error,
    brandKdsFetching: isFetching,
    brandKdsLoading: isLoading,
    brandKdsRefetch: refetch
  };
};

const getData = async (id) => {
  let result = await client.get(`/kdsscreen/findAllByBrand/${id}`);
  result = result.data?.kdsscreens;
  return result;
};
